<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.$t('components.service.modal.InvoiceDetails.1') }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <CustomSelectButton
            class="w-100 mb16"
            v-model:modelValue="this.section"
            :options="this.sections"
            @changeStage="this.selectSection"
        />
        <div v-if="this.section === '0'" class="bg-light-grey rounded12 border-full" :class="{ 'p16': !this.isMobile, 'p8': this.isMobile }">
            <div class="bg-white mb16" :class="{ 'py16 px12': this.isMobile, 'py32 px24': !this.isMobile }"> 
                <div>
                    <div class="pb16 mb16 border-b d-flex justify-content-between align-items-center">
                        <div>
                            <div class="fsp20 lh28 neue">{{ this.$t('components.service.modal.InvoiceDetails.2') }}</div>
                            <div class="fsp14 lh20 neue-roman">#{{ this.content.code }}</div>
                        </div>
                        <div class="bg-light-blue p10 rounded-circle">
                            <img :src="this.$store.state.logoMobile.img" class="logo" />
                        </div>
                    </div>
                    <div class="d-flex flex-column gap-2 fsp12 lh16 mb16 pb16 border-b">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.3') }}</div>
                            <div 
                                class="fsp12 text-nowrap neue" 
                                :class="{ 
                                    'status-text-green': this.content.status == 'paid', 
                                    'status-text-grey': this.content.status == 'created',
                                    'status-text-grey-2': this.content.status == 'expired',
                                    'status-text-red': this.content.status == 'cancelled', 
                                    'status-text-red-2': this.content.status == 'failed',
                                    'status-text-orange': this.content.status == 'paused',
                                    'status-text-blue': this.content.status == 'returned'
                                }"
                            >
                                {{ this.transformStatusText(this.content.status) }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.4') }}</div>
                            <div class="text-truncate neue">{{ this.formatDate(this.content.dt_create) }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.5') }}</div>
                            <div class="text-truncate neue">{{ this.formatDate(this.content.dt_final) }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.6') }}</div>
                            <div class="text-truncate neue">{{ this.content.sum }} {{ this.invoiceInfo.invoice_curr_text }}</div>
                        </div>
                        <div v-if="Number(this.comiss)" class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.7') }}</div>
                            <div class="text-truncate neue">{{ Number(this.comiss) }} {{ this.invoiceInfo.invoice_curr_text }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.8') }}</div>
                            <div class="text-truncate neue">{{ this.content.shop_number }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.9') }}</div>
                            <div class="text-truncate neue">{{ getStoreName() }}</div>
                        </div>
                        <div v-if="this.content.comment" class="border-full p8 fsp12 lh16 mt8">
                            <span class="primary-grey neue-roman mr4">{{ this.$t('components.service.modal.InvoiceDetails.10') }}</span>
                            <span>{{ this.content.comment }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-column gap-2 fsp12 lh16 mb16 pb16 border-b">
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.11') }}</div>
                            <div class="text-truncate neue">{{ this.content.transact }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.12') }}</div>
                            <div class="text-truncate neue">{{ this.advanced.name_corr.split(': ')[1] ? this.advanced.name_corr.split(': ')[1] : this.$t('components.service.modal.InvoiceDetails.32') }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.13') }}</div>
                            <div class="text-truncate neue">1 {{ this.invoiceInfo.invoice_curr_text }} = {{ this.rate }} {{ this.invoiceInfo.pay_curr_text }}</div>
                        </div>
                        <div v-if="Number(this.invoiceInfo?.discount_percent) !== 0 && this.invoiceInfo?.discount_percent" class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">
                                {{ isDiscount ? this.$t('components.service.modal.InvoiceDetails.14') : this.$t('components.service.modal.InvoiceDetails.31') }} 
                                ({{ this.invoiceInfo?.discount }}%)
                            </div>
                            <div class="text-truncate neue">{{ this.invoiceInfo?.discount_percent.replace('-', '') }} {{ this.invoiceInfo?.invoice_curr_text }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.30') }}</div>
                            <div class="text-truncate neue">{{ this.advanced.s_sum.split(':')[1] }} {{ this.invoiceInfo.invoice_curr_text }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.15') }}</div>
                            <div class="text-truncate neue">{{ this.content.keyt_shop }}</div>
                        </div>
                        <div v-if="this.export_postings.length" class="d-flex justify-content-between align-items-center gap-2">
                            <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.16') }}</div>
                            <div class="text-truncate neue">{{ this.export_postings[0].explorer_link }}</div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center fsp20 lh28 neue">
                        <div class="primary-grey d-flex align-items-center">
                            <span class="text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.17') }}</span>
                            <Popper :hover="true">
                                <Icon name="info" class="c16 pointer ml4" />
                                <template #content>
                                    <label class="fsp14 lh20 neue-roman text-white">
                                        {{ this.$t('components.service.modal.InvoiceDetails.18') }}
                                    </label>
                                </template>
                            </Popper>
                        </div>
                        <div>{{ this.advanced.s_sum.split(':')[1] }} {{ this.invoiceInfo.invoice_curr_text }}</div>
                    </div>
                </div>
            </div>
            <div class="bg-white rounded">
                <Button 
                    @click="this.downloadPDF()"
                    @mouseover="hoverIcon = 'download-file'" 
                    @mouseleave="hoverIcon = false" 
                    type="btn-outline-grey w-100"
                    class="h40"
                >
                    <Icon name="download-file" class="c20 pointer mr8" :active="hoverIcon !== 'download-file'" />
                    {{ this.$t('components.service.modal.InvoiceDetails.19') }}
                </Button>
            </div>
        </div>
        <div v-if="this.section === '1'" class="bg-light-grey rounded12 border-full" :class="{ 'p16': !this.isMobile, 'p8': this.isMobile }">
            <div class="bg-white" :class="{ 'py16 px12': this.isMobile, 'py32 px24': !this.isMobile }">
                <div class="fsp20 lh28 neue mb16 pb16 border-b">{{ this.$t('components.service.modal.InvoiceDetails.20') }}</div>
                <div class="d-flex justify-content-between align-items-center fsp12 lh16">
                    <div class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.InvoiceDetails.21') }}</div>
                    <div class="d-flex align-items-center gap-1 min-w-0">
                        <a :href="this.advanced.callback_request" target="_blank" class="ml16 text-truncate neue text-truncate">{{ this.advanced.callback_request }}</a>
                        <Icon name="copy" class="c16 pointer" @click="this.copy(this.advanced.callback_request)"/>
                    </div>
                </div>
                <Warning fontSize="14" :warning="this.warning" :hideCloseBtn="true" class="m-0 my16 fsp14" />
                <CallbackTable :callbacks="callbacks" />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';
import CustomSelectButton from '@/components/service/CustomSelectButton.vue';
import Button from '@/components/service/Button.vue';
import Popper from '@/components/service/Popper.vue';
import Warning from '@/components/service/Warning.vue';
import CallbackTable from '@/components/service/CallbackTable.vue';

export default {
    name: 'InvoiceDetails',
    components: {
        Icon,
        CustomSelectButton,
        Button,
        Popper,
        Warning,
        CallbackTable
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            section: '0',
            sections: [
                { label: this.$t('components.service.modal.InvoiceDetails.22'), value: '0' },
                { label: this.$t('components.service.modal.InvoiceDetails.20'), value: '1' },
            ],
            content: this.$store.state.modal.content.invoice,
            cmdResponse: this.$store.state.modal.content.cmdResponse,
            shopList: this.$store.state.modal.content.shopList,
            hoverIcon: false,
            warning: {
                warningType: this.getNotificationType,
                warningText: ''
            },
            shopInfo: false,
            export_postings: false,
            rate: false,
            comiss: false,
            invoiceInfo: false,
            advanced: false,
            callbacks: false,
            showAll: false,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        isDiscount() {
            return !this.invoiceInfo?.discount_percent.startsWith('-');
        },
        //callbackContent() {
        //    return this.showAll ? this.callbacks : this.callbacks.slice(0, 3);
        //}
    },
    created() {
        this.advanced = this.cmdResponse[1];
        this.invoiceInfo = this.cmdResponse[0].find(e => e.name == 'invoice')?.colvalues[0];
        this.export_postings = this.cmdResponse[0].find(e => e.name == 'export_postings')?.colvalues;
        this.callbacks = this.cmdResponse[0].find(e => e.name == 'merchant_callbacks_tries')?.colvalues;
        this.rate = Number(this.advanced.rate.split(':')[1]);
        this.comiss = this.advanced.s_shop_comiss.split(':')[1];
        this.warning = {
            warningType: this.getNotificationType(),
            warningText: this.advanced.callback_status_text
        }
    },
    methods: {
        getNotificationType() {
            if(this.advanced.callback_status == '30') {
                return 'notification';
            } else if(this.advanced.callback_status == '20') {
                return 'warning';
            } else if(this.advanced.callback_status == '40') {
                return 'error';
            }
        },
        formatDate(date) {
            return date.split(' ')[0].split('-').reverse().join('.') + ', ' + date.split(' ')[1];
        },
        getPDFData() {
            const content = [
                {
                    [this.$t('components.service.modal.InvoiceDetails.3')]: `${this.transformStatusText(this.content.status)}`,
                    [this.$t('components.service.modal.InvoiceDetails.4')]: `${this.formatDate(this.content.dt_create)}`,
                    [this.$t('components.service.modal.InvoiceDetails.5')]: `${this.formatDate(this.content.dt_final)}`,
                    [this.$t('components.service.modal.InvoiceDetails.6')]: `${this.content.sum} ${this.invoiceInfo.invoice_curr_text}`,
                    [this.$t('components.service.modal.InvoiceDetails.7')]: `${Number(this.comiss) } ${this.invoiceInfo.invoice_curr_text}`,
                    [this.$t('components.service.modal.InvoiceDetails.8')]: `${this.content.shop_number}`,
                    [this.$t('components.service.modal.InvoiceDetails.9')]: `${this.getStoreName()}`,
                    [this.$t('components.service.modal.InvoiceDetails.10')]: `${this.content.comment}`,
                }, 
                {
                    [this.$t('components.service.modal.InvoiceDetails.11')]: `${this.content.transact}`,
                    [this.$t('components.service.modal.InvoiceDetails.12')]: `${this.advanced.name_corr.split(': ')[1] ? this.advanced.name_corr.split(': ')[1] : this.$t('components.service.modal.InvoiceDetails.32')}`,
                    [this.$t('components.service.modal.InvoiceDetails.13')]: `1 ${this.invoiceInfo.invoice_curr_text} = ${this.rate} ${this.invoiceInfo.pay_curr_text}`,
                    [`${this.$t('components.service.modal.InvoiceDetails.14')} (${this.invoiceInfo?.discount_percent.replace('-', '')}%)`]: `${this.invoiceInfo?.discount_percent.replace('-', '')} ${this.invoiceInfo.invoice_curr_text}`,
                    [`${this.$t('components.service.modal.InvoiceDetails.31')} (${this.invoiceInfo?.discount_percent.replace('-', '')}%)`]: `${this.invoiceInfo?.discount_percent.replace('-', '')} ${this.invoiceInfo.invoice_curr_text}`,
                    [this.$t('components.service.modal.InvoiceDetails.30')]: `${this.advanced.s_sum.split(':')[1]} ${this.invoiceInfo.invoice_curr_text}`,
                    [this.$t('components.service.modal.InvoiceDetails.15')]: `${this.content.keyt_shop}`,
                    [this.$t('components.service.modal.InvoiceDetails.16')]: `${this.export_postings.length ? this.export_postings[0].explorer_link : ''}`,
                }
            ]
            if(!this.isDiscount) {
                delete content[1][`${this.$t('components.service.modal.InvoiceDetails.14')} (${this.invoiceInfo?.discount_percent.replace('-', '')}%)`];
            } else {
                delete content[1][`${this.$t('components.service.modal.InvoiceDetails.31')} (${this.invoiceInfo?.discount_percent.replace('-', '')}%)`];
            }
            if(!Number(this.comiss)) {
                delete content[0][this.$t('components.service.modal.InvoiceDetails.7')];
            }
            if(!this.content.comment) {
                delete content[0][this.$t('components.service.modal.InvoiceDetails.10')];
            }
            if(this.invoiceInfo.discount_percent == '0.00') {
                delete content[1][`${this.$t('components.service.modal.InvoiceDetails.14')} (${this.invoiceInfo?.discount_percent.replace('-', '')}%)`];
                delete content[1][`${this.$t('components.service.modal.InvoiceDetails.31')} (${this.invoiceInfo?.discount_percent.replace('-', '')}%)`];
            }
            if(!this.export_postings.length) {
                delete content[1][this.$t('components.service.modal.InvoiceDetails.16')];
            }
            return {
                title: `${this.$t('components.service.modal.InvoiceDetails.2')} #${this.content.code}`,                    
                content,
                end: {
                    [this.$t('components.service.modal.InvoiceDetails.17')]: `${this.advanced.s_sum.split(':')[1]} ${this.invoiceInfo.invoice_curr_text}`,
                }
            }
        },
        downloadPDF() {
            //console.log(this.getPDFData());
            const form = document.createElement('form');
            form.method = 'GET';
            form.action = '/DownloadPDF';
            form.target = '_blank';

            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'data';
            input.value = JSON.stringify(this.getPDFData());
            form.appendChild(input);
            
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },

        transformStatusText(status) {
            return this.$lib.getInvoiceStatusText(status);
        },
        getStoreName() {
            return this.shopList.find(shop => shop.code == this.content.shop_number)?.name;
        },
        selectSection(section) {
            this.section = section;
        },
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
        getShopTicker() {
            return this.shopList.find(shop => shop.num == this.content.shop_number)?.keyt_shop;
        },
    }
}
</script>

<style lang="scss" scoped>
.logo {
    width: 28px;
    height: 28px;
}
</style>